<template lang="html">
    <select @input="$emit('input', $event)">
        <option 
            v-if="initialValue"
            :value="initialValue" 
            selected="selected">
            {{initialOptionName}}
        </option>
        <option 
            v-else
            value="" 
            disabled="disabled" 
            selected="selected">
            {{placeholder}}
        </option>

        <option
            v-for="(item, key) in items"
            :key="'select-' + key"
            :value="item.value"
            :selected="value === item.name">
            {{ item.name }}
        </option>
    </select>
</template>

<script>
export default {
    props: {
        items: {
            type: Array
        },
        placeholder: {
            type: String,
            default: ''
        },
        initialValue: {
            type: String,
            default: null
        },
        initialOptionName: {
            type: String,
            default: null
        }
    },
    data() {
        return {
        value: null
        };
    }
}
</script>